<template>
    <el-container style="height:100%;margin:0px;">
        <el-aside width="auto">
            <!-- <comAside ></comAside> -->
            <comAside :list="caiDan"></comAside>
        </el-aside>
        <el-container>
            <el-header style="background:#545c64">
                <p class="top_right">
                    <!-- <span>登录时间：2021-02-15 13:00</span> -->
                    <span>{{name}}</span>
                    <span style="border-right:0px;cursor: pointer;" @click="out_login"><i class="el-icon-switch-button"></i>退出</span>
                </p> 
            </el-header>
            <el-main>
                <div class="cont">
                    <router-view/>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import comAside from './comAside.vue'
    import {getNavigation} from '@/utils/api'
    export default {
        name:"Index",
        components:{
            comAside,
        },
        data(){
            return{
                idx:1,
                name:'用户',
                caiDan:[],
                list:[]
            }
        },
        methods:{
            out_login(){
                localStorage.clear();
                this.$router.push({
                    path:'/DengL'
                })
            },
            getType(type){
                this.idx=type
            }
        },
        mounted(){
            let user=JSON.parse(localStorage.getItem('userInfo'))
            this.name=user.name
            getNavigation({userId:user.uid}).then(res=>{
                this.caiDan=res;
               // this.$router.push(this.caiDan[0].path);
               
           })
        },
    }
</script>
<style lang="less" scoped>
    html,body{
        margin:0px;
    }
    .el-header{
        background:#000;
    }
    .el-main{
        padding:20px;
        .cont{
            width:100%;
            height:100%;
            background:#fff;
            border-radius:15px;
            box-shadow: 2px 0 5px 2px rgba(0,0,0,.1);
            padding:20px;
            box-sizing:border-box;
        }
    }
    .top_right{
        color:#fff;
        text-align:right;
    }
    .top_right span{
        margin-right:30px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Index.vue